import React, {useEffect} from "react";
import {Routes, Route, useNavigate} from "react-router";
import Ticket from "../Screens/Tickets/index.tsx";
import Users from "../Screens/User/index.tsx";
import Chat from "./Chat/index.tsx";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "../store/store.tsx";
import {fetchConfigData} from "../store/configSlice.tsx";
import useAuth0 from "../common/Auth0Provider/use-auth0.ts";
import {fetchMetraIds} from "@store/chatSlice.tsx";
import AddUser from "./User/components/AddUser/index.tsx";
import {fetchSecurityGroups} from "@store/securityGroupsSlice.tsx";
import UserProfile from "./UserProfile/index.tsx";
import {fetchCountryCodeList} from "@store/addUserSlice.tsx";

const AppRoutes: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const {user} = useSelector((state: any) => state.user)
    const {isAuthenticated, logout} = useAuth0();
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(fetchConfigData());
            dispatch(fetchSecurityGroups())
            dispatch(fetchMetraIds(user?.hospitalId));
            dispatch(fetchCountryCodeList())
        }
    }, [isAuthenticated]);

    useEffect(() => {
        if ('serviceWorker' in navigator) {
            //   navigator.serviceWorker.addEventListener('error', (event: Event) => {
            //     console.error('Service Worker runtime error:', event);
            //   });

            navigator.serviceWorker.ready.then((registration) => {
                if (registration.active) {
                    registration.active.onerror = (event) => {
                        console.log("An error occurred in the service worker!", event);
                    };
                }
            });
        }
    }, []);

    console.log("navigator.serviceWorker.getRegistrations()", navigator.serviceWorker.getRegistrations())

    useEffect(() => {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.addEventListener('message', (event) => {
                console.log('Service worker received message:', event.data);
                if (event.data.type === 'notification-clicked') {
                    const route = event.data.route || '/';
                    navigate(route); // Navigate inside your React app
                }
                if (event.data.type === 'LOGOUT_USER') {
                    console.log('Service worker requested logout due to inactivity.');
                    logout({
                        logoutParams: {
                            returnTo: window.location.origin,
                        },
                    });
                }
            });
        }
    }, [navigate]);

    return (
        <Routes>
            <Route path="/" element={<Ticket/>}/>
            <Route path="/users" element={<Users/>}/>
            <Route path="/users/new" element={<AddUser/>}/>
            <Route path="/users/:id" element={<AddUser/>}/>
            <Route path="/userInfo/:id" element={<UserProfile/>}/>
            <Route path="/chat/:id" element={<Chat/>}/>
        </Routes>
    );
};

export default AppRoutes;
